export enum IntegrationActionTypes {
  LOAD_INTEGRATION_STATUS = "INTEGRATION_LOAD_STATUS",
  LOAD_INTEGRATION_STATUS_SUCCESS = "INTEGRATION_LOAD_STATUS_SUCCESS",
  LOAD_INTEGRATION_STATUS_ERROR = "INTEGRATION_LOAD_STATUS_ERROR",

  DISCONNECT_PLATFORM = "INTEGRATION_DISCONNECT",
  DISCONNECT_PLATFORM_SUCCESS = "INTEGRATION_DISCONNECT_SUCCESS",
  DISCONNECT_PLATFORM_ERROR = "INTEGRATION_DISCONNECT_ERROR",

  SYNC_PRODUCTS = "INTEGRATION_SYNC_PRODUCTS",
  SYNC_PRODUCTS_SUCCESS = "INTEGRATION_SYNC_PRODUCTS_SUCCESS",
  SYNC_PRODUCTS_ERROR = "INTEGRATION_SYNC_PRODUCTS_ERROR",

  LOAD_WEBHOOK_LOGS = "INTEGRATION_LOAD_WEBHOOK_LOGS",
  LOAD_WEBHOOK_LOGS_SUCCESS = "INTEGRATION_LOAD_WEBHOOK_LOGS_SUCCESS",
  LOAD_WEBHOOK_LOGS_ERROR = "INTEGRATION_LOAD_WEBHOOK_LOGS_ERROR",
}
